import { useRef, useState } from "react"

import { LoginButton, LoginWrapper, LoginFormMain } from "./Atom"
import styles from "../../../styles/Login.module.css"
import {
  Box,
  Checkbox,
  CircularProgress,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { useNavigate } from "react-router-dom"
import { VisibilityOff, Visibility } from "@mui/icons-material"

type LoginProps = {
  loading: boolean
  setEmail: any
  setPassword: any
  handleLogin: any
  emailError: any
  passwordError: any
}

const Login = (props: LoginProps) => {
  const {
    loading,
    setEmail,
    setPassword,
    handleLogin,
    emailError,
    passwordError,
  } = props

  const navigate = useNavigate()

  const inputRefs: any = useRef([])

  const [showPassword, setShowPassword] = useState(false)

  const handleKeyPress = (index: any) => {
    const nextIndex = index + 1
    inputRefs.current[nextIndex]?.focus()
  }

  const handleClickEnter = (e: any, index: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleKeyPress(index)
    }
  }

  const handleClickSubmit = (e: any, index: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleLogin()
    }
  }

  const handleClickOnForgotPassword = () => {
    navigate("/forgotPassword")
  }

  return (
    <LoginWrapper>
      <h4 className={styles.LoginText}>LOGIN</h4>
      {/* <form noValidate autoComplete="off" onSubmit={() => { handleLogin(email, password) }}> */}
      <LoginFormMain>
        <TextField
          id="email"
          sx={{
            marginTop: "0px",
          }}
          type="email"
          error={emailError ? true : false}
          helperText={emailError}
          autoFocus
          required
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => handleClickEnter(e, 0)}
          label="Email ID"
          className={styles.TextInput}
          // inputProps={{ onKeyPress: handleKeyPress(0) }}
          inputRef={(ref) => (inputRefs.current[0] = ref)}
          autoComplete="email"
        />
        <TextField
          id="password"
          sx={{
            marginTop: "15px",
          }}
          type={showPassword ? "text" : "password"}
          error={passwordError ? true : false}
          helperText={passwordError}
          required
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => handleClickSubmit(e, 1)}
          label="Password"
          className={styles.TextInput}
          inputRef={(ref) => (inputRefs.current[1] = ref)}
          autoComplete="new-password"
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={() => setShowPassword(!showPassword)}
                sx={{ cursor: "pointer" }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
            ),
          }}
        />
      </LoginFormMain>

      {/* Remember Me Checkbox and Forget Password */}

      <Box
        sx={{
          // border: "1px solid red",
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        {/* <Box
          sx={{
            // border: "1px solid red",
            display: "flex",
            width: "100%",
            alignItems: "center",
            padding: "0",
          }}
        >
          <Box>
            <Checkbox sx={{ padding: "0" }} />
          </Box>
          <Box sx={{ display: "flex", marginLeft: "5px" }}>
            <Typography>
              I Agree to the
            </Typography>
            <Typography color={"#3366D6"} fontWeight={600} sx={{ marginLeft: "5px", cursor: "pointer", textDecoration: "underline" }}>
              Terms of Use
            </Typography>
          </Box>
        </Box> */}
        <Box
          sx={{
            // border: "1px solid red",
            display: "flex",
            width: "100%",
            cursor: "pointer",
            marginTop: "0px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
          onClick={handleClickOnForgotPassword}
        >
          <Typography color={"#3C77EF"}>Forgot Password?</Typography>
        </Box>
      </Box>

      {/* Login Button */}

      <LoginButton
        // type="submit"
        variant="contained"
        onClick={() => {
          handleLogin()
        }}
        // onFocus={() => { handleLogin(email, password, "focus") }}
        endIcon={
          loading ? (
            <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
          ) : (
            <ArrowForwardIcon />
          )
        }
        ref={(ref) => (inputRefs.current[2] = ref)}
      >
        <Typography
          style={{ textTransform: "none" }}
          fontSize={16}
          fontWeight={500}
        >
          Login
        </Typography>
      </LoginButton>
      {/* </form> */}
    </LoginWrapper>
  )
}

export default Login
